import React from 'react';

import Text from '../../text/text';

import './lesson-banner-view__description.scss';

interface Props {
    text?: string | null;
}

export const LessonBannerViewDescription = React.memo(({ text }: Props) => {
    if (!text) {
        return null;
    }

    return (
        <div className="lesson-banner-view__description">
            <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN}>
                {text}
            </Text>
        </div>
    );
});
